import * as React from 'react';
import React__default, { memo, useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useStyles } from '@sravni/react-utils';
import { Accordion, Typography, Breadcrumb, Avatar, Badge, Icon, Carousel } from '@sravni/react-design-system';
import { Verification, Star } from '@sravni/react-icons';

var modules_d9e61c20 = {"content":"_57c9p2","container":"_1qyiu22","title":"_2cfbqs","accordion":"_z3vt4y","accordionItem":"_11y9ur8","itemTitle":"_1w4hpqv","itemContent":"_ei8f8p"};
/*SRAVNI__src/src/FAQ/styles/FAQ.module.less__SRAVNI*/;

var FAQ$1 = memo(function (_a) {
    var _b;
    var _c, _d;
    var className = _a.className, title = _a.title, items = _a.items;
    var cx = useStyles(modules_d9e61c20);
    return (React__default.createElement("div", { className: cx(className, modules_d9e61c20.container) },
        React__default.createElement("h2", { className: modules_d9e61c20.title }, title),
        React__default.createElement("div", { className: cx((_b = {}, _b[modules_d9e61c20.accordion] = items.length > 1, _b)) }, items.length > 1 ? (React__default.createElement(Accordion, { defaultIndex: [0] }, items.map(function (item, index) { return (React__default.createElement(Accordion.Item, { key: index, title: React__default.createElement("h3", null, item.question), className: modules_d9e61c20.accordionItem, unmountOnExit: false },
            React__default.createElement("span", { className: modules_d9e61c20.content, dangerouslySetInnerHTML: { __html: item.answer } }))); }))) : (React__default.createElement("div", null,
            ((_c = items[0]) === null || _c === void 0 ? void 0 : _c.question) && React__default.createElement("div", { className: modules_d9e61c20.itemTitle }, items[0].question),
            React__default.createElement("div", { className: modules_d9e61c20.itemContent, dangerouslySetInnerHTML: { __html: (_d = items[0]) === null || _d === void 0 ? void 0 : _d.answer } }))))));
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var modules_8f751419 = {"content":"_12a469","container":"_1w8ckyc","subTables":"_9ffocv","title":"_1ikn26u"};
/*SRAVNI__src/src/TopOffers/styles/TopOffers.module.less__SRAVNI*/;

var TopOffers$1 = memo(function (props) {
    var cx = useStyles(modules_8f751419);
    var className = props.className, title = props.title, _a = props.subTitle, subTitle = _a === void 0 ? '' : _a;
    var renderSubTables = useCallback(function (items) {
        if (!(items === null || items === void 0 ? void 0 : items.length)) {
            return null;
        }
        return items.map(function (item, index) { return (React__default.createElement("div", { key: item.header },
            React__default.createElement(Typography.Text, { as: 'h3', size: 16, className: 'h-mt-20' },
                index + 1,
                ". ",
                item.header),
            item.subHeader && (React__default.createElement(Typography.Text, { size: 16, className: 'h-mt-12', dangerouslySetInnerHTML: { __html: String(item.subHeader) } })),
            React__default.createElement("table", { className: modules_8f751419.subTables },
                React__default.createElement("tbody", null, item.rows
                    .filter(function (_a) {
                    var _b = __read(_a, 2); _b[0]; var value = _b[1];
                    return value;
                })
                    .map(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return (React__default.createElement("tr", { key: key },
                        React__default.createElement("td", null, key),
                        React__default.createElement("td", null, value)));
                }))))); });
    }, []);
    var renderDefault = useCallback(function (headers, rows) {
        if (!(rows === null || rows === void 0 ? void 0 : rows.length)) {
            return null;
        }
        return (React__default.createElement("table", null,
            React__default.createElement("tbody", null,
                React__default.createElement("tr", null, headers === null || headers === void 0 ? void 0 : headers.map(function (item, index) { return (React__default.createElement("th", { key: index }, item)); })), rows === null || rows === void 0 ? void 0 :
                rows.map(function (row, rowIndex) {
                    return (React__default.createElement("tr", { key: rowIndex }, row === null || row === void 0 ? void 0 : row.map(function (item, index) { return (React__default.createElement("td", { key: index }, item)); })));
                }))));
    }, []);
    var content = useMemo(function () {
        if (props.mode === 'subTables') {
            return renderSubTables(props.items);
        }
        return renderDefault(props.headers, props.rows);
    }, []);
    return content ? (React__default.createElement("div", { className: cx(className, modules_8f751419.container) },
        React__default.createElement("h2", { className: modules_8f751419.title }, title),
        React__default.createElement("div", { className: modules_8f751419.content },
            React__default.createElement("div", { dangerouslySetInnerHTML: { __html: subTitle } }),
            content))) : null;
});

var modules_87882407 = {"container":"_1jmr8yx","item":"_pno3j"};
/*SRAVNI__src/src/Breadcrumbs/styles/Breadcrumbs.module.less__SRAVNI*/;

var Breadcrumbs$1 = memo(function (_a) {
    var className = _a.className, items = _a.items, _b = _a.needMainPage, needMainPage = _b === void 0 ? true : _b;
    var cx = useStyles(modules_87882407);
    if (items.length === 0) {
        return null;
    }
    var firstElem = needMainPage ? [{ url: '/', title: 'Сравни.ру' }] : [];
    var breadcrumbs = __spreadArray(__spreadArray([], __read(firstElem), false), __read(items), false);
    return items.length > 0 ? (React__default.createElement(Breadcrumb, { className: cx(className, modules_87882407.container) }, breadcrumbs.map(function (item, index) {
        var isLast = breadcrumbs.length - 1 === index;
        return (React__default.createElement(Breadcrumb.Item, { className: cx(modules_87882407.item), key: index, href: isLast ? undefined : item.url, rel: isLast ? 'nofollow' : undefined }, item.title));
    }))) : null;
});
Breadcrumbs$1.defaultProps = {
    items: []
};

var Check = function (_a) {
    var className = _a.className;
    return (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "#00AFFF" }),
        React__default.createElement("path", { d: "M13 8L8.875 12L7 10.1818", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};

function getCharArr(rowCut) {
    var charArr = [];
    var subRow;
    var match;
    var char;
    for (var i = 0; i < rowCut.length; i++) {
        subRow = rowCut.substring(i);
        match = subRow.match(/^&[a-z0-9#]+;/);
        if (match) {
            char = match[0];
            charArr.push(char);
            i += char.length - 1;
        }
        else {
            charArr.push(rowCut[i]);
        }
    }
    return charArr;
}
var trimHtml = function (html, options) {
    options = options || {};
    var limit = options.limit || 100;
    var preserveTags = typeof options.preserveTags !== 'undefined' ? options.preserveTags : true;
    var wordBreak = typeof options.wordBreak !== 'undefined' ? options.wordBreak : false;
    var suffix = options.suffix || '...';
    var moreLink = options.moreLink || '';
    var moreText = options.moreText || '»';
    var preserveWhiteSpace = options.preserveWhiteSpace || false;
    var arr = html
        .replace(/</g, '\n<')
        .replace(/>/g, '>\n')
        .replace(/\n\n/g, '\n')
        .replace(/^\n/g, '')
        .replace(/\n$/g, '')
        .split('\n');
    var sum = 0;
    var row;
    var cut;
    var add;
    var tagMatch;
    var tagName;
    var tagStack = [];
    var more = false;
    var rowCut;
    for (var i = 0; i < arr.length; i++) {
        row = arr[i];
        // count multiple spaces as one character
        if (!preserveWhiteSpace) {
            rowCut = row.replace(/[ ]+/g, ' ');
        }
        else {
            rowCut = row;
        }
        if (!row.length) {
            continue;
        }
        var charArr = getCharArr(rowCut);
        if (row[0] !== '<') {
            if (sum >= limit) {
                row = '';
            }
            else if (sum + charArr.length >= limit) {
                cut = limit - sum;
                if (charArr[cut - 1] === ' ') {
                    while (cut) {
                        cut -= 1;
                        if (charArr[cut - 1] !== ' ') {
                            break;
                        }
                    }
                }
                else {
                    add = charArr.slice(cut).indexOf(' ');
                    // break on halh of word
                    if (!wordBreak) {
                        if (add !== -1) {
                            cut += add;
                        }
                        else {
                            cut = row.length;
                        }
                    }
                }
                row = charArr.slice(0, cut).join('') + suffix;
                if (moreLink) {
                    row += '<a href="' + moreLink + '" style="display:inline">' + moreText + '</a>';
                }
                sum = limit;
                more = true;
            }
            else {
                sum += charArr.length;
            }
        }
        else if (!preserveTags) {
            row = '';
        }
        else if (sum >= limit) {
            tagMatch = row.match(/[a-zA-Z]+/);
            tagName = tagMatch ? tagMatch[0] : '';
            if (tagName) {
                if (row.substring(0, 2) !== '</') {
                    tagStack.push(tagName);
                    row = '';
                }
                else {
                    while (tagStack[tagStack.length - 1] !== tagName && tagStack.length) {
                        tagStack.pop();
                    }
                    if (tagStack.length) {
                        row = '';
                    }
                    tagStack.pop();
                }
            }
            else {
                row = '';
            }
        }
        arr[i] = row;
    }
    return {
        html: arr.join('\n').replace(/\n/g, ''),
        more: more
    };
};

var trimText = function (text, limit, wordBreak) {
    var output = trimHtml(text, { limit: limit, wordBreak: wordBreak });
    if (output.html.length - 3 === text.length) {
        output.html = text;
    }
    return { __html: output.html || '', more: output.more };
};

function getLimit(width) {
    var limit = 300;
    if (width < 1260) {
        limit = 200;
    }
    if (width < 600) {
        limit = 100;
    }
    if (width < 350) {
        limit = 80;
    }
    return limit;
}

var modules_5aaa8cf0 = {"content":"_xrxoxd","container":"_s5k0ew","header":"_18nzw39","header__image":"_eye3j2","header__label":"_1m6sozn","header__title":"_61vwwn","description":"_4m0bv","line":"_15nvlol","link":"_9j4zt2","ref":"_1btagc0"};
/*SRAVNI__src/src/components/Answer/styles/Answer.module.less__SRAVNI*/;

var Answer$1 = memo(function (_a) {
    var answer = _a.answer;
    var cx = useStyles(modules_5aaa8cf0);
    var refRow = useRef(null);
    var _b = __read(useState(0), 2), dimensions = _b[0], setDimensions = _b[1];
    var _c = __read(useState({
        expanded: false,
        truncated: false
    }), 2), state = _c[0], setState = _c[1];
    useEffect(function () {
        if (refRow.current) {
            setDimensions(refRow.current.offsetWidth);
        }
    }, []);
    var handleResize = function () {
        if (refRow.current) {
            setDimensions(refRow.current.offsetWidth);
        }
    };
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var getDescription = useMemo(function () {
        if (state.expanded) {
            return { __html: answer.description || '' };
        }
        var trim = trimText(answer.description || '', getLimit(dimensions), true);
        setState(__assign(__assign({}, state), { truncated: trim.more }));
        return { __html: trim.__html };
    }, [dimensions, state.expanded]);
    var handleClickMore = function () {
        setState({
            truncated: false,
            expanded: true
        });
    };
    var clickToExpertIcon = useCallback(function () {
        window.open(answer.link);
    }, [answer.link]);
    return (React.createElement("div", { ref: refRow, className: cx('container') },
        React.createElement("div", { className: modules_5aaa8cf0.ref, onClick: clickToExpertIcon },
            React.createElement("div", { className: cx('header') },
                React.createElement(Avatar, { className: cx('header__image'), src: "https://f.sravni.ru/avatars/".concat(answer.expertId, "-s.svg"), size: 52 }),
                React.createElement("div", null,
                    React.createElement("div", { className: cx('header__label') },
                        answer.name,
                        React.createElement(Check, null)),
                    React.createElement("div", { className: cx('header__title') }, answer.role)))),
        (answer === null || answer === void 0 ? void 0 : answer.description) && (React.createElement("div", { className: cx('description') },
            React.createElement("span", { dangerouslySetInnerHTML: getDescription }),
            "\u2002",
            state.truncated && (React.createElement("a", { className: modules_5aaa8cf0.link, onClick: handleClickMore, rel: "nofollow" }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")))),
        React.createElement("div", { className: cx('line') }),
        React.createElement("div", { className: modules_5aaa8cf0.content, dangerouslySetInnerHTML: { __html: answer.text } })));
});

var modules_019d20e3 = {"content":"_djk5e","container":"_1ytb90h","title":"_ue1xqa"};
/*SRAVNI__src/src/ExpertOpinion/styles/ExpertOpinion.module.less__SRAVNI*/;

var ExpertOpinion$1 = memo(function (_a) {
    var className = _a.className, title = _a.title, answersData = _a.answersData;
    var cx = useStyles(modules_019d20e3);
    return (React__default.createElement("div", { className: cx(className, modules_019d20e3.container) },
        React__default.createElement("h2", { className: modules_019d20e3.title }, title),
        answersData.map(function (answer) { return (React__default.createElement(Answer$1, { key: answer.expertId, answer: answer })); })));
});

var modules_eea27586 = {"content":"_1s0y6yl","container":"_138s8ux","header":"_8fxyix","header__image":"_qv3xvk","header__label":"_1wvm1l7","header__title":"_12ie3ms","description":"_nstuj","line":"_1313onz","link":"_18y5cnf"};
/*SRAVNI__src/src/components/Author/styles/Author.module.less__SRAVNI*/;

var Author$1 = function (_a) {
    var _b = _a.author, author = _b === void 0 ? {} : _b;
    var cx = useStyles(modules_eea27586);
    var refRow = useRef(null);
    var _c = __read(useState(0), 2), dimensions = _c[0], setDimensions = _c[1];
    var _d = __read(useState({
        expanded: false,
        truncated: false
    }), 2), state = _d[0], setState = _d[1];
    useEffect(function () {
        if (refRow.current) {
            setDimensions(refRow.current.offsetWidth);
        }
    }, []);
    var handleResize = function () {
        if (refRow.current) {
            setDimensions(refRow.current.offsetWidth);
        }
    };
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var getDescription = useMemo(function () {
        if (state.expanded) {
            return { __html: author.description || '' };
        }
        var trim = trimText(author.description || '', getLimit(dimensions), true);
        setState(__assign(__assign({}, state), { truncated: trim.more }));
        return { __html: trim.__html };
    }, [dimensions, state.expanded]);
    var handleClickMore = function () {
        setState({
            truncated: false,
            expanded: true
        });
    };
    return (React.createElement("div", { ref: refRow, className: cx('container') },
        React.createElement("div", { className: cx('header') },
            React.createElement(Avatar, { className: cx('header__image'), src: author.image, size: 52 }),
            React.createElement("div", null,
                React.createElement("div", { className: cx('header__label') },
                    author.name,
                    React.createElement(Check, null)),
                React.createElement("div", { className: cx('header__title') },
                    "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0421\u0440\u0430\u0432\u043D\u0438.\u0440\u0443",
                    author.email && ", ".concat(author.email)))),
        (author === null || author === void 0 ? void 0 : author.description) && (React.createElement("div", { className: cx('description') },
            React.createElement("span", { dangerouslySetInnerHTML: getDescription }),
            "\u2002",
            state.truncated && (React.createElement("a", { className: modules_eea27586.link, onClick: handleClickMore, rel: "nofollow" }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")))),
        React.createElement("div", { className: cx('line') })));
};

var modules_dcfc971f = {"content":"_5va8xn","container":"_rbi4ty","item":"_3doigc"};
/*SRAVNI__src/src/Html/styles/Html.module.less__SRAVNI*/;

var modules_b0191299 = {"content":"_1pkw3ln","title":"_q6gvrv","internal":"_1b0m1db"};
/*SRAVNI__src/src/Html/components/item/Item.module.less__SRAVNI*/;

var Item$1 = function (_a) {
    var className = _a.className, text = _a.text, title = _a.title;
    var cx = useStyles(modules_b0191299);
    return (React.createElement("div", { className: cx(className, 'content') },
        React.createElement("h2", { className: cx('title') }, title),
        React.createElement("div", { className: cx('internal'), dangerouslySetInnerHTML: { __html: text } })));
};

var Html$1 = memo(function (_a) {
    var className = _a.className, text = _a.text, author = _a.author;
    if (!text || !text.length)
        return null;
    var cx = useStyles(modules_dcfc971f);
    return (React__default.createElement("section", { "data-qa": 'seo-accordion' },
        React__default.createElement("div", { className: cx(className, 'container') },
            author && React__default.createElement(Author$1, { author: author }), text === null || text === void 0 ? void 0 :
            text.map(function (item, index) { return (React__default.createElement(Item$1, { key: index, className: modules_dcfc971f.item, text: item.text, title: item.title })); }))));
});

var modules_b63ec0b9 = {"container":"_g1yq65","item":"_19rqvgc"};
/*SRAVNI__src/src/SeoBlock/styles/SeoBlock.module.less__SRAVNI*/;

var SeoBlock$1 = memo(function (_a) {
    var className = _a.className, contentBlocks = _a.contentBlocks;
    var cx = useStyles(modules_b63ec0b9);
    var renderComponent = function (data) {
        switch (data.type) {
            case 'topOffers': {
                if ('topOffersComponent' in data) {
                    return data.topOffersComponent;
                }
                if (data.mode === 'subTables') {
                    return (React__default.createElement(TopOffers$1, { className: data.className, mode: data.mode, title: data.title, subTitle: data.subTitle, items: data.items }));
                }
                return (React__default.createElement(TopOffers$1, { className: data.className, title: data.title, subTitle: data.subTitle, headers: data.headers, rows: data.rows }));
            }
            case 'faq': {
                return React__default.createElement(FAQ$1, { className: data.className, title: data.title, items: data.items });
            }
            case 'html': {
                return React__default.createElement(Html$1, { className: data.className, text: data.text, author: data.author });
            }
            case 'expertOpinion': {
                return React__default.createElement(ExpertOpinion$1, { className: data.className, title: data.title, answersData: data.answersData });
            }
            case 'bestproduct': {
                return data.bestProductComponent;
            }
            case 'review': {
                return data.reviewsComponent;
            }
            case 'seoBanner': {
                return data.seoBannerComponent;
            }
            default:
                return null;
        }
    };
    return (React__default.createElement("div", { className: cx(className, modules_b63ec0b9.container) }, contentBlocks.map(function (item, index) {
        return React__default.createElement(React__default.Fragment, { key: index }, renderComponent(item));
    })));
});

var modules_6567b526 = {"review-inner":"_2d8uus","block":"_1bq78av","block__header":"_av8j4x","block__star":"_71yfmv","block__bank-info":"_e3hn99","block__organization-name":"_14r1t6s","block__content":"_1429tpc","block__logo":"_szdr0s","block__image":"_t38zbl","block__title":"_ugxwyk","block__text":"_b027hy","block__name":"_15ggcpm","block__rating":"_1f3ewdn","link":"_sapf7j","text":"_1et05kl","text__hidden":"_3qnw3r","linkContainer":"_h3dkjb"};
/*SRAVNI__src/src/Reviews/components/Item/ReviewItem.module.less__SRAVNI*/;

var ReviewItem$1 = React__default.memo(function (_a) {
    var productType = _a.productType, className = _a.className, _b = _a.item, logo = _b.logo, title = _b.title, text = _b.text, alias = _b.alias, id = _b.id, authorName = _b.authorName, locationName = _b.locationName, rating = _b.rating, organizationName = _b.organizationName, isPremiumPartner = _b.isPremiumPartner, partnerCard = _b.partnerCard;
    var cx = useStyles(modules_6567b526);
    var reviewLink = "/".concat(productType, "/").concat(alias, "/otzyvy/").concat(id, "/");
    var organizationLink = "/".concat(productType, "/").concat(alias, "/otzyvy/");
    var getText = useMemo(function () {
        var limit = 80;
        var trimmedText = trimText(text, limit, true);
        //TODO: change native <a> to <Typography.Link/>
        //when the issue is fixed https://github.com/facebook/react/issues/16416
        trimmedText.__html = "".concat(trimmedText.__html, " <a href=").concat(reviewLink, " class=").concat(cx('linkContainer'), " target=\"_blank\">\u0427\u0438\u0442\u0430\u0442\u044C</a>");
        return trimmedText;
    }, [reviewLink]);
    var handleOpenLink = useCallback(function (link) {
        return function (event) {
            event.stopPropagation();
            window.open(link, '_blank');
        };
    }, []);
    var handlePropagation = useCallback(function (event) {
        event.stopPropagation();
    }, []);
    var renderLogo = function () { return (React__default.createElement("a", { className: cx('block__logo', 'link'), href: organizationLink, target: "_blank", rel: "noreferrer", onClick: handlePropagation },
        React__default.createElement("img", { className: cx('block__image'), src: logo, alt: "" }))); };
    return (React__default.createElement("div", { className: cx('block', 'link', className), onClick: handleOpenLink(reviewLink) },
        React__default.createElement("div", { className: cx('review-inner') },
            React__default.createElement("div", null,
                React__default.createElement("div", { className: cx('block__header') },
                    logo &&
                        (isPremiumPartner || partnerCard ? (React__default.createElement(Badge, { variant: "primary", color: "light", text: React__default.createElement(Verification, { color: "#00AFFF" }), shape: "circle", placement: "bottom-end" }, renderLogo())) : (renderLogo())),
                    React__default.createElement("div", { className: cx('block__bank-info') },
                        organizationName && (React__default.createElement("a", { href: organizationLink, target: "_blank", rel: "noreferrer", onClick: handlePropagation, title: organizationName, className: cx('block__organization-name') }, organizationName)),
                        React__default.createElement("div", { className: cx('block__rating') }, rating && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Icon, { className: cx('block__star'), size: 16, color: "orange", icon: React__default.createElement(Star, null) }),
                            React__default.createElement("span", null, String(rating))))))),
                React__default.createElement("div", { className: cx('block__content') },
                    title && (React__default.createElement(Typography.Link, { href: reviewLink, className: cx('block__title'), target: "_blank", onClick: handlePropagation },
                        React__default.createElement("span", { className: cx('text') }, title))),
                    text && (React__default.createElement("div", { className: cx('block__text') },
                        React__default.createElement("noindex", null,
                            React__default.createElement("span", { dangerouslySetInnerHTML: getText, className: cx('text') })),
                        React__default.createElement("span", { className: cx('text__hidden') }, text))))),
            authorName && locationName && (React__default.createElement("div", { className: cx('block__name') },
                React__default.createElement("span", null,
                    authorName,
                    ", ",
                    locationName))))));
});

var modules_1aa6dec7 = {"container":"_wugw8n","container__inner":"_w26k1f","container__carousel":"_1f07lek","container__link":"_1dt8tka"};
import "./assets/index.esm-21224b68.css";

var Reviews$1 = React.memo(function (props) {
    var cx = useStyles(modules_1aa6dec7);
    var className = props.className, reviewItemClassName = props.reviewItemClassName, heading = props.heading, reviews = props.reviews, productType = props.productType, allReviewsLink = props.allReviewsLink, _a = props.gradient, gradient = _a === void 0 ? true : _a, restProps = __rest(props, ["className", "reviewItemClassName", "heading", "reviews", "productType", "allReviewsLink", "gradient"]);
    return (React.createElement("div", __assign({ className: cx(className, 'container') }, restProps),
        React.createElement("div", { className: cx('container__inner', 'container__carousel') },
            React.createElement(Carousel, { title: React.createElement("h2", null, heading), gradient: gradient }, reviews.map(function (item) { return (React.createElement(ReviewItem$1, { key: "review-".concat(item.id), className: reviewItemClassName, item: item, productType: productType })); }))),
        React.createElement("div", { className: cx('container__link') },
            React.createElement(Typography.Link, { href: allReviewsLink, target: "_blank" }, "\u0427\u0438\u0442\u0430\u0442\u044C \u0432\u0441\u0435 \u043E\u0442\u0437\u044B\u0432\u044B"))));
});

export { Breadcrumbs$1 as Breadcrumbs, ExpertOpinion$1 as ExpertOpinion, FAQ$1 as FAQ, Html$1 as Html, Reviews$1 as Reviews, SeoBlock$1 as SeoBlock, TopOffers$1 as TopOffers };
